
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    this.$forceUpdate();
    return this.data;
  }
  private change(ev: any) {
    this.$emit("update", this.c);
  }
}
